import { AddToModelParamList, STATICMETHOD } from "../utils";

/**
 * Decorator that will determine a static method on the database model
 * 
 * @return Function
 *   Will return a function that will be used by the Reflection API to build out everything on the object
 */
export function StaticMethod() {
    return (target: any, propertyKey: string) => {
        AddToModelParamList((target.prototype === undefined ? target : target.prototype), propertyKey);
        Reflect.defineMetadata(STATICMETHOD, target[propertyKey], target, propertyKey);
    }
}